module.exports = __webpack_public_path__ + "user-default.png?f1fad84204790679e6e745130d15fd9e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/user-default.png
// module id = 520
// module chunks = 2